import { LocalStorageService } from './../../../core/services/local-storage.service';
import { environment } from './../../../../environment/environment';
import { SortDataService } from './../../../core/services/sortdata';
import { DatePipe } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { headerColumns } from './../../../core/models/entreprise';
import {
  blockSuccess,
  deblockSuccess,
  dejabloque,
  serverError,
} from './../../../core/models/messages';
import { CompanyService } from './../../../core/services/company/company.service';
import { EsnAppeloffreService } from './../../../core/services/esn-appeloffre/esn-appeloffre.service';
import { Country } from 'country-state-city';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { translations } from '../../../core/models/call-offer';
import { SubscriptionService } from '@core/services/subscription.service';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-liste-entreprises',
  templateUrl: './liste-entreprises.component.html',
  styleUrls: ['./liste-entreprises.component.css'],
})
export class ListeEntreprisesComponent {
  freeSearchActive :boolean = false;
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  freeSearch: boolean = false;
  btnSearchactive : boolean = false;
  isCollapsed = true; // Initial state
  private unsubscribeAll: Subject<void> = new Subject();
  /* any */
  file: any;
  selectedImage: any;
  /* modal */
  //  modalRef?: BsModalRef;
  /* object */
  responsableCompany: any;
  /* arrays */
  listCampany: any = [];
  hasActiveSubscription : any ;
  dataHeader: any = [];
  listNames: string[] = [];
  typesCompanies = [
    { id: 1, name: 'Entreprise' },
    { id: 2, name: 'ESN' },
    { id: 3, name: 'Client Final' },
    { id: 4, name: 'Cabinet de Recrutement' },
  ];
  /* number */
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  totalItems!: number;
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  pagination : boolean =false;

  startIndex: number = 0;
  endIndex: number = 5;
  currentUser: any;
  isLoadSpinner: boolean = true;


  /* string */
  mode: string = 'create';
  url: string = environment.baseUrl + '/api';
  urlimage: string = environment.baseUrlGalery;
  fileError: string = '';
  fileExtention: string = '';
  fileName: string = '';
  /* formGroup */
  loadSpinnerTable: boolean = false;
  loadSpinner: boolean = false;
  companyRoleId: any;
  companyType = new FormControl();
  /* form data */
  formData = new FormData();
  paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  typeCompany = [
     { id: 1, name: 'Entreprise' },
    { id: 2, name: 'ESN' },
    // { id: 3, name: 'Client Final' },
    { id: 4, name: 'Cabinet de Recrutement' },
  ];
  currentSortColumn: string = 'name';
  activeForm: 'freeSearch' | 'guidedSearch' | null = null;
  /* unsubscription */

  searchForm: FormGroup = this.createSearchForm();
  freeSearchForm: FormGroup = this.createFreeSearchForm();
  pays = [
    { id: 1, name: 'France' },
    { id: 2, name: 'Tunisie' },
    { id: 3, name: 'Turquie' },
    { id: 4, name: 'Allemagne' },
  ];
  sortAttr = '';
  headerColumns: { checked: boolean; name: string; code: string }[] =
    headerColumns;
  typeintervenant: any;
  idclientConnected: any;
  typee:any

  startSearching:boolean = false;

  constructor(
    private companyService: CompanyService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private appelOffreService: EsnAppeloffreService,
    private toastr: ToastrService,
    private router: Router,
    private datePipe: DatePipe,
    private sortdata: SortDataService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private subscriptionService: SubscriptionService
  ) {}
  ngOnInit() {
    this.typeintervenant = this.localStorageService.getData('typeintervenant');
    this.searchCompnies();
    
    this.getListElementHeader();
    this.getcurrentUser()
    this.idclientConnected =
      this.localStorageService.getData('clientConnected');

      const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
      scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');
    
    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
   displayFreeSearch() {
   this.freeSearch = !this.freeSearch;
    if(this.freeSearch) {
      this.searchForm = this.createSearchForm();
      this.searchForm.reset();
      this.activeForm = 'freeSearch';
   }
   else {
     this.freeSearchForm.reset();
     this.freeSearchForm = this.createFreeSearchForm();
     this.activeForm = 'guidedSearch'
   }
   this.currentPage=0;
   //this.getListCompanies();
   this.searchForm.markAsDirty()
   this.searchCompnies()
  }
  getListElementHeader() {
    if (!this.typeintervenant) {
      this.appelOffreService
        .getHeaderElements(12)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    } else {
      this.companyService
        .listPageActorIntervenant()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.dataHeader = res.data;
            for (const iterator of this.dataHeader) {
              if (
                (iterator.checked == 'oui' && !iterator.checked_user) ||
                (iterator.checked == 'non' && iterator.checked_user == 'oui') ||
                (iterator.checked == 'oui' && iterator.checked_user == 'oui')
              )
                this.listNames.push(iterator.name);
            }
            this.dataHeader.map((el: any) => {
              if (
                (el.checked == 'oui' && !el.checked_user) ||
                (el.checked_user == 'oui' &&
                  (el.checked == 'non' || el.checked == 'oui'))
              ) {
                return (el.checkAdmin = true);
              } else {
                return (el.checkAdmin = false);
              }
            });
          },
          error: () => {},
        });
    }
  }

  changeSelection(event: any, data: any, i: number) {
    this.listNames = [];
    data.checkAdmin = event.target.checked;
    for (const iterator of this.dataHeader) {
      if (iterator.checkAdmin) this.listNames.push(iterator.name);
    }
    this.changeSelectionHeadrElements(data);
  }
  changeSelectionHeadrElements(data: any) {
    if (!this.typeintervenant) {
      if (this.idclientConnected == '2') {
        let payload = {
          sub_page_id: data?.id,
        };
        this.companyService
          .changeDelectedElementHeader(payload)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res) => {},
            error: () => {},
          });
      } else {
        let payload = {
          sub_page_id: data?.id,
        };
        this.companyService
          .changeDelectedElementcfHeader(payload)
          .pipe(takeUntil(this.unsubscribeAll))
          .subscribe({
            next: (res) => {},
            error: () => {},
          });
      }
    } else {
      let payload = {
        sub_page_id: data?.id,
      };
      this.companyService
        .changeSubPageStateIntervenant(payload)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {},
          error: () => {},
        });
    }
  }
  toggleCollapsible() {
    this.isCollapsed = !this.isCollapsed;
  }
 onPageChange(e: PageEvent): void {
    const { pageSize, pageIndex } = e;
    this.pageSize = pageSize;
    this.currentPage = pageIndex;
    if (this.searchForm.dirty && !this.freeSearch) {
        this.searchCompnies();
    } 
    else if (this.freeSearchForm.dirty && this.freeSearch) {
        this.freesearchCompnies(this.currentPage);
    } 
    else {
        this.searchForm.markAsDirty()
        this.searchCompnies()
    }
  }
  handleRatingClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('bs-rating-star')) {
      // Check if the "active" class is present
      const isActive = target.classList.contains('active');
      // Toggle the "active" class
      target.classList.toggle('active', !isActive);
    }
  }
  translateCountryName(name: string): string {
   
    return translations[name] || name;
  }
  sortData(item: string) {
    for (const iterator of headerColumns) {
      if (item == iterator.name) item = iterator.code;
    }
    this.sortAttr = item;
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.currentPage = 1;
    this.endIndex = 5;
    if (this.searchForm.dirty)
      this.listCampany = this.sortdata.sortArray(
        this.listCampany,
        item,
        this.currentSortDirection
      );
    else this.getListCompanies();
  }

  /* list list esn companies */
  getListCompanies() {
    this.spinner.show();
    const params = {
      type: 2,
      per_page: this.pageSize,
      page: this.currentPage, 
    }
    this.companyService
      .listCompany(params)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('ttte',params)
          this.isLoadSpinner = false;
          this.listCampany = res.data.data
          this.typee=res.data.data.type  
          // .slice(0, this.endIndex);
          
          this.totalItems = res.data.total;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  //////////////////////////////date de creation pour afficher dans la liste ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

  formatDate(dateString: string | null): string {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'yyyy-MM-dd') || '';
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));
      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
    }
    // this.addCandidateFormGroup.markAsDirty();
  }

  //////////////////////////////////////////bloquer/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  bloquer(idCompany: any) {
    Swal.fire({
      title: " Vous êtes sûr de bloquer l'entreprise sélectionnée ? ",
      icon: 'warning',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, bloquer',
      cancelButtonText: 'Annuler', // Changer le texte du bouton Cancel ici
    }).then((result) => {
      if (result.isConfirmed) {
        this.blockCompany(idCompany);
        this.getListCompanies();
      }
    });
  }
  debloquer(idCompany: any) {
    Swal.fire({
      title: " Vous êtes sûr de débloquer l'entreprise sélectionnée ? ",
      icon: 'warning',
      iconColor: '#ff0000',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'oui, débloquer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (result.isConfirmed) {
        this.deblockCompany(idCompany);
        this.getListCompanies();
      }
    });
  }
  /* deblock  company */
  deblockCompany(idCompany: any) {
    this.spinner.show();
    this.companyService
      .deblockCompany(idCompany)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(deblockSuccess);
          this.getListCompanies();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }

  /* block  company */
  blockCompany(idCompany: any) {
    this.spinner.show();
    this.companyService
      .blockCompany(idCompany)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.toastr.success(blockSuccess);
          this.getListCompanies();
        },
        error: () => {
          this.toastr.error(dejabloque);
        },
      });
  }

  /* search */
  createSearchForm(data?: any) {
     return this.formBuilder.group({
      ID_company: [data ? data.ID_company : ''],
      name: [data ? data.name : ''],
      note: [data ? data.note : 0],
      typeComp: [data ? data.typeComp : null],
      blocked: [data ? data.blocked : null],
      country: [data ? data.country : null],
      search: ['', [Validators.pattern(/"([^"]*"(and|not|,|&&)[^"]*)*"/)]],
    });
  }
  createFreeSearchForm(){
    return this.formBuilder.group({
      search: [
        '',
        [Validators.pattern(/^("([^"]*"(AND|NOT|,|&&)[^"]*)*"|[^\s"']+)$/)],
      ],
    });
  }
  reset() {
   this.currentPage = 0;
    this.searchForm.reset();
    this.freeSearchForm.reset();
    this.freeSearchForm = this.createFreeSearchForm();
    this.searchForm = this.createSearchForm();
    this.spinner.hide();
    //this.getListCompanies();
    this.searchForm.markAsDirty()
    this.searchCompnies();
  }
   searchCompnies(pageNumber: number = this.currentPage) {
    this.btnSearchactive = true;
    let data = {
      name: this.searchForm.value?.name,
      typeComp: !this.searchForm.value.typeComp
        ? ''
        : this.searchForm.value.typeComp.toString(),
      country: !this.searchForm.value.country
        ? []
        : this.searchForm.value.country,
      note: this.searchForm.value.note,
      ID_company: this.searchForm.value.ID_company,
      page: this.currentPage,
      per_page: this.pageSize,
      blocked: this.searchForm.value.blocked,
    }
    this.spinner.show()
    if (data.note === 0) {
      data.note = ""
    }
    this.companyService
      .searchCompany(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;
          this.listCampany = res.data.data;
          this.totalItems = res.data.total;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

   freesearchCompnies(pageNumber: number = this.currentPage) {
    let valueForm = this.freeSearchForm.value;

    let data = {
      page: this.currentPage,
      per_page: this.pageSize,
      search: this.transformSearch(valueForm?.search),
    }
    this.spinner.show();
    this.companyService.searchCompany(data).subscribe({
          next: (resSearch) => {
              const { to, from, total, current_page, data } = resSearch.data;
              this.startSearching = false;
              this.listCampany= resSearch.data.data;
              this.totalItems = resSearch.data.total;
              this.spinner.hide();
          },
          error: (error) => {
              this.spinner.hide();
          },
      });
  }


  transformSearch(search: string): string {
    // Remplace toutes les occurrences de '||' par 'OR'
    search = search.replace(/\|\|/g, ' OR ');

    // Remplace toutes les occurrences de '&&' par ' AND '
    search = search.replace(/&&/g, ' AND ');

    // Remplace toutes les occurrences de '!' par ' NOT '
    search = search.replace(/!/g, ' NOT ');

    search = search.replace(/\b(AND|OR|NOT)\b/g, ' $1 ');

    search = search.replace(/"([^"]+)"|(\S+)/g, (match, p1, p2) => {
      if (p1) {
        return `"${p1}"`;
      } else {
        // Si le terme n'est pas entre guillemets, échappe les guillemets simples à l'intérieur du terme
        const escapedTerm = p2.replace(/"/g, '\\"');
        return `${escapedTerm}`;
      }
    });

    search = search.replace(/\s+/g, ' ');

    return search.trim();
  }


  /* ************************* navigation contact responsable ********************* */
  contactResponsableNavigation(id: any) {
    this.router.navigate(['/contact', { idResponsable: id }]);
  }

  /* ************************* navigation contact responsable ********************* */
  VoiroffreNavigation(id: any) {
    this.router.navigate(['/entreprises/offre-entreprise', { id: id }]);
  }
   setActiveForm(form: 'freeSearch' | 'guidedSearch') {
    this.activeForm = form;
    if (form === 'freeSearch') {
      this.freeSearchActive = true;
      this.freeSearchForm.enable(); 
    } else if (form === 'guidedSearch') {
      this.freeSearchActive = false;
      this.searchForm.enable();
    }
}
  onSubmit() {
    if(!this.freeSearchActive) {
      this.btnSearchactive = true;
      this.currentPage = 0;
      this.searchCompnies(1);
    } else{
      this.btnSearchactive = true;
      this.currentPage = 0;
       this.freesearchCompnies(1);
    }
  }
  /* ************************* navigation contact responsable ********************* */
  reviewCompanyNavigation(id: any) {
    this.router.navigate(['/evaluer-esn', { id: id }]);
  }
  getcurrentUser() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.companyRoleId = JSON.parse(this.currentUser).role_user_id;
  }
  isEsnNotSubscribed(): boolean {
    
    return this.companyRoleId!= undefined ? this.companyRoleId.includes('8')  : false;
  }
  isEsnSubscribed(): boolean {
    return this.companyRoleId!= undefined ? this.companyRoleId.includes('7')  : false;
  }

  unSubscribedEsn(): boolean {
    return this.subscriptionService.unSubscribedEsn();
  }

  ngOnDestroy() {
    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));
  }

  formatUrl(link: string): string {
    if (!link.startsWith('http://') && !link.startsWith('https://')) {
      return `https://${link}`;
    }
    return link;
  }
}
